import { Checkbox } from '@components/checkbox';
import { OtherDocuments } from '../otherDocuments';
import type { AboTranchePropsType } from './types';

const AboTranche: React.FC<AboTranchePropsType> = (props: AboTranchePropsType) => (
  <tr className="AboTranche max-[1100px]:flex max-[1100px]:max-w-[565px] max-[1100px]:flex-wrap max-[1100px]:items-center max-[1100px]:justify-between max-[1100px]:border-b max-[1100px]:border-[#e4e4e4] max-[1100px]:bg-[#fbfbfb] max-[1100px]:p-2.5 max-[620px]:max-w-[calc(100vw-40px)] max-[600px]:[&>td]:mt-2.5 max-[600px]:[&>td.AboTranche-documents]:mt-px">
    <td className="AboTranche-fundsname max-[1100px]:w-full max-[1100px]:text-[13px] max-[1100px]:text-accent" key={`${props.id}_1`}>
      {props.tranche.fundsname}
    </td>
    <td className="AboTranche-isin max-[1100px]:inline-block max-[1100px]:border-b-0 max-[1100px]:leading-[15px]" key={`${props.id}_2`}>
      {props.tranche.isin}
    </td>
    <td className="AboTranche-all max-[1100px]:hidden" key={`${props.id}_3`}>
      <Checkbox
        checked={Number(props.tranche.all) === 1}
        indeterminate={Number(props.tranche.all) === 2}
        updateCallback={(newVal) => {
          props.checkFn([props.id], ['all'], newVal);
        }}
      />
    </td>
    <td className="AboTranche-kid max-[1100px]:hidden" key={`${props.id}_4`}>
      <Checkbox
        checked={props.tranche.kid}
        updateCallback={(newVal) => {
          props.checkFn([props.id], ['kid'], newVal);
        }}
      />
    </td>
    <td className="AboTranche-factsheet max-[1100px]:hidden" key={`${props.id}_5`}>
      <Checkbox
        checked={props.tranche.factsheet}
        updateCallback={(newVal) => {
          props.checkFn([props.id], ['factsheet'], newVal);
        }}
      />
    </td>
    <td className="AboTranche-documents relative max-[1100px]:inline-block max-[1100px]:border-b-0 max-[1100px]:leading-[15px] max-[600px]:w-full" key={`${props.id}_6`}>
      <OtherDocuments
        id={props.id}
        checkFn={props.checkFn}
        otherDocuments={{ other: props.tranche.other, otherall: props.tranche.otherall }}
        documentLabels={props.documentLabels as any}
        excludedColsInOtherDocs={props.excludedColsInOtherDocs}
      />
    </td>
  </tr>
);

export { AboTranche };
